var version = {
    "name":      "dativery",
    "buildDateCode": "20260623-125736",
    "buildDate": "Tue Jun 23 2026 12:57:36 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260623-125736",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;